import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

const setWellnessReward = async function(rewardData, rewardId = null) {
    const db = firebase.firestore();
    const rewardRef = rewardId ? db.collection('wellness_rewards').doc(rewardId) : db.collection('wellness_rewards').doc();
    
    if (!rewardId) {
        rewardData.id = rewardRef.id;
    }
    
    await rewardRef.set(rewardData, { merge: true });
    return rewardRef.id;
};

export default setWellnessReward; 